<template>
  <div ref="bing" class="bing"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: "Bing1",
  data() {
    return{
      data:{},
      option : {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          left: "10%",
          top: "10%",
          orient: "vertical",
          textStyle:{
            color:"#fff"
          }
        },
        series: [
          {
            name: '营收额',
            left: '30%',
            top: '15%',
            height:"85%",
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '26',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 10, name: '汝南县' },
              { value: 5, name: '上蔡县' },
              { value: 2, name: '西平县' },
              { value: 1, name: '遂平县' },
              { value: 5, name: '泌阳县' },
              { value: 3, name: '确山县' },
              { value: 1, name: '正阳县' },
              { value: 1, name: '新蔡县' },
              { value: 1, name: '平舆县' },
            ]
          }
        ]
      }
    }
  },
  methods: {
    init() {
      this.myChart = echarts.init(this.$refs.bing);
      this.myChart.setOption(this.option);
    },
  },
  mounted() {
    let user_id = window.localStorage.getItem('user_id');

    const data = {
      'user_id': user_id
    };


      this.option ={
        tooltip: {
          trigger: 'item'
        },
        legend: {
          left: "10%",
          top: "10%",
          orient: "vertical",
          textStyle:{
            color:"#fff"
          }
        },
        series: [
          {
            name: '营收额',
            left: '30%',
            top: '15%',
            height:"85%",
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '26',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 10, name: '汝南县' },
              { value: 5, name: '上蔡县' },
              { value: 2, name: '西平县' },
              { value: 1, name: '遂平县' },
              { value: 5, name: '泌阳县' },
              { value: 3, name: '确山县' },
              { value: 1, name: '正阳县' },
              { value: 1, name: '新蔡县' },
              { value: 1, name: '平舆县' },
            ]
          }
        ]
      }
      this.myChart = echarts.init(this.$refs.bing);
      this.myChart.setOption(this.option);
 
  },
  watch: {
    data(value) {
      this.option.data = value;
      this.myChart.setOption(this.option);
    },
  }
}
</script>

<style scoped>
 .bing{
   height: 100%;
   width: 100%;
 }
</style>